import gql from 'graphql-tag';

export default gql`
query orderStatuses {
    orderStatuses {
        id
        title
        code
    }
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/orderStatuses.ts